import React, { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Mail } from 'lucide-react';
import Auth from '../../../js/tb/Auth';


const VIEW_STATES = {
    INITIAL: 'initial',
    CANCELED: 'canceled',
    UNSUBSCRIBED: 'unsubscribed',
}

const UnsubscribeEmailNotifications = () => {
    const [view, setView] = useState(VIEW_STATES.INITIAL);
    const [isLoading, setIsLoading] = useState(false);

    const { template_id } = useParams();
    const [searchParams] = useSearchParams();

    const userEmail = searchParams.get('email');


    const handleSubmit = async () => {
        setIsLoading(true);
        await TB.wait(1000);

        const hash = searchParams.get('hash');

        const didUnsubscribe = await Auth.unsubscribeToEmails({
            email: userEmail,
            hash,
            template_id,
        });

        if (didUnsubscribe) {
            setView(VIEW_STATES.UNSUBSCRIBED)
        } else {
            TB.alert(
                'error', 'Something went wrong',
                'Unable to unsubscribe at this time, please try again later',
            );
        }

        setIsLoading(false);
    }


    return (
        <div className="pb-5 flex-1 flex items-center justify-center">
            <div className="shadow-lg bg-white p-6 max-w-md mt-6 pt2 text-center w-full">

                <div className="w-16 h-16 bg-[#e9e4f6] rounded-full flex items-center justify-center mx-auto mb-6">
                    <Mail className="w-8 h-8 text-wripplePrimaryDarkPurple" />
                </div>

                {view === VIEW_STATES.INITIAL && (
                    <div>
                        <p className="text-2xl">Unsubscribe from Notifications</p>

                        <div className="bg-wripplePrimaryDarkPurple p-0.5 w-3/4 my-4 mx-auto" />

                        <p className="text-sm">You are about to unsubscribe from {template_id ? 'this topic' : 'all email notifications'}</p>

                        <div className="flex justify-center pt-6">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSubmit}
                                disabled={isLoading}
                            >
                                Unsubscribe from Emails
                            </button>
                        </div>

                        <div className="flex justify-center pt-2">
                            <button type="button" className="btn btn-outline" onClick={() => setView(VIEW_STATES.CANCELED)}>
                                Cancel
                            </button>
                        </div>
                    </div>
                )}

                {view === VIEW_STATES.UNSUBSCRIBED && (
                    <div>
                        <p className="text-2xl">Successfully Unsubscribed</p>

                        <div className="bg-wripplePrimaryDarkPurple p-0.5 w-3/4 my-4 mx-auto" />

                        <p className="text-gray-600 mb-4">
                            <span className="font-medium block">{userEmail}</span> has been removed from our mailing list.
                        </p>
                        <p className="text-gray-600 mb-6">
                            You won't receive any more emails from {template_id ? 'this topic' : 'us'}. This change is effective immediately.
                        </p>
                        <p className="text-sm text-gray-500">
                            You can safely close this tab now.
                        </p>
                    </div>
                )}

                {view === VIEW_STATES.CANCELED && (
                    <div>
                        <p className="text-2xl">No Changes Made</p>

                        <div className="bg-wripplePrimaryDarkPurple p-0.5 w-3/4 my-4 mx-auto" />

                        <p className="text-gray-600 mb-6">
                            You'll continue receiving emails as usual.
                        </p>
                        <p className="text-sm text-gray-500">
                            You can safely close this tab now.
                        </p>
                    </div>
                )}

            </div>
        </div>
    );
}

export default UnsubscribeEmailNotifications;